var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgColorSwatch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.2001 1.60001C2.77575 1.60001 2.36878 1.76858 2.06873 2.06864C1.76867 2.36869 1.6001 2.77566 1.6001 3.20001V12C1.6001 12.6365 1.85295 13.247 2.30304 13.6971C2.75313 14.1472 3.36358 14.4 4.0001 14.4C4.63662 14.4 5.24707 14.1472 5.69715 13.6971C6.14724 13.247 6.4001 12.6365 6.4001 12V3.20001C6.4001 2.77566 6.23153 2.36869 5.93147 2.06864C5.63141 1.76858 5.22444 1.60001 4.8001 1.60001H3.2001ZM4.0001 12.8C4.21227 12.8 4.41575 12.7157 4.56578 12.5657C4.71581 12.4157 4.8001 12.2122 4.8001 12C4.8001 11.7878 4.71581 11.5843 4.56578 11.4343C4.41575 11.2843 4.21227 11.2 4.0001 11.2C3.78792 11.2 3.58444 11.2843 3.43441 11.4343C3.28438 11.5843 3.2001 11.7878 3.2001 12C3.2001 12.2122 3.28438 12.4157 3.43441 12.5657C3.58444 12.7157 3.78792 12.8 4.0001 12.8ZM8.0001 11.3944L11.9201 7.47441C12.2201 7.17436 12.3886 6.76747 12.3886 6.34321C12.3886 5.91894 12.2201 5.51205 11.9201 5.21201L10.7881 4.08001C10.4881 3.78005 10.0812 3.61155 9.6569 3.61155C9.23264 3.61155 8.82574 3.78005 8.5257 4.08001L8.0001 4.60561V11.3944ZM12.8001 14.4H7.2569L12.0569 9.60001H12.8001C13.2244 9.60001 13.6314 9.76858 13.9315 10.0686C14.2315 10.3687 14.4001 10.7757 14.4001 11.2V12.8C14.4001 13.2244 14.2315 13.6313 13.9315 13.9314C13.6314 14.2314 13.2244 14.4 12.8001 14.4Z",
    fill: "#09090B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgColorSwatch);
export default __webpack_public_path__ + "static/media/ColorSwatch.42d52c334b7279613fc8bd67a60f4a0e.svg";
export { ForwardRef as ReactComponent };